/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfDesignRequestPublicationAttemptDto } from "../models/AjaxResponseOfDesignRequestPublicationAttemptDto";
import type { AjaxResponseOfPublishDesignRequestOutput } from "../models/AjaxResponseOfPublishDesignRequestOutput";
import type { AjaxResponseOfStaffDesignPublicationDetailDto } from "../models/AjaxResponseOfStaffDesignPublicationDetailDto";
import type { AjaxResponseOfStaffDesignPublicationsOutput } from "../models/AjaxResponseOfStaffDesignPublicationsOutput";
import type { AjaxResponseOfTikTokPublicationPreviewOutput } from "../models/AjaxResponseOfTikTokPublicationPreviewOutput";
import type { DesignRequestPublicationStatus } from "../models/DesignRequestPublicationStatus";
import type { StaffRetryDesignPublicationsInput } from "../models/StaffRetryDesignPublicationsInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class StaffDesignPublicationsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfStaffDesignPublicationsOutput Success
   * @throws ApiError
   */
  public get({
    filter,
    teamId,
    provider,
    placement,
    status,
    from,
    to,
    archiveView,
    attentionOnly,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    teamId?: number;
    provider?: string;
    placement?: string;
    status?: DesignRequestPublicationStatus;
    from?: string;
    to?: string;
    archiveView?: string;
    attentionOnly?: boolean;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfStaffDesignPublicationsOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/design-publications",
      query: {
        filter: filter,
        teamId: teamId,
        provider: provider,
        placement: placement,
        status: status,
        from: from,
        to: to,
        archiveView: archiveView,
        attentionOnly: attentionOnly,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfStaffDesignPublicationDetailDto Success
   * @throws ApiError
   */
  public getDetail({
    attemptId,
  }: {
    attemptId: number;
  }): CancelablePromise<AjaxResponseOfStaffDesignPublicationDetailDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/staff/design-publications/{attemptId}",
      path: {
        attemptId: attemptId,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public dismiss({
    attemptId,
  }: {
    attemptId: number;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/staff/design-publications/{attemptId}",
      path: {
        attemptId: attemptId,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public restore({
    attemptId,
  }: {
    attemptId: number;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/design-publications/{attemptId}/restore",
      path: {
        attemptId: attemptId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPublishDesignRequestOutput Success
   * @throws ApiError
   */
  public retry({
    designRequestId,
    requestBody,
  }: {
    designRequestId: number;
    requestBody?: StaffRetryDesignPublicationsInput;
  }): CancelablePromise<AjaxResponseOfPublishDesignRequestOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/design-publications/{designRequestId}/retry",
      path: {
        designRequestId: designRequestId,
      },
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfDesignRequestPublicationAttemptDto Success
   * @throws ApiError
   */
  public refreshTikTok({
    attemptId,
  }: {
    attemptId: number;
  }): CancelablePromise<AjaxResponseOfDesignRequestPublicationAttemptDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/design-publications/{attemptId}/tiktok/refresh",
      path: {
        attemptId: attemptId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTikTokPublicationPreviewOutput Success
   * @throws ApiError
   */
  public getTikTokPreview({
    attemptId,
  }: {
    attemptId: number;
  }): CancelablePromise<AjaxResponseOfTikTokPublicationPreviewOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/staff/design-publications/{attemptId}/tiktok/preview",
      path: {
        attemptId: attemptId,
      },
    });
  }
}
